import { useSelector } from "react-redux";

const usePermissions = () => {
  const { userPermissions, userRole } = useSelector((state: any) => state.auth);

  if (userRole === "super_user") {
    return { hasPermission: () => true };
  }

  const hasPermission = (permission: string) => {
    return userPermissions && userPermissions[permission] === true;
  };

  return {
    hasPermission,
  };
};

export default usePermissions;
